/*! License details at fancyapps.com/license */
import { clamp as o } from "./clamp.js";
var t = function t() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var p = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  var s = (t - n) / (r - n) * (m - c) + c;
  return p ? c < m ? o(c, s, m) : o(m, s, c) : s;
};
export { t as map };